import Rollbar from 'rollbar';
import config from '../config';
import expectedErrors from '../config/expectedApiErrors';

export const handleExpectedErrors = errorInfo => {
  let handled = false;

  expectedErrors.forEach(error => {
    if (errorInfo.endpoint?.includes(error.endpoint) && errorInfo.message.startsWith(error.messageStart)) {
      window.Rollbar.warn(error.rollbarItem, errorInfo);
      handled = true;
    }
  });

  return handled;
};

export const logApiError = error => {
  const buildRollbarInfo = err => {
    let errorMessage = '';
    if (err.response.data) {
      errorMessage = err.response.data.message;
    }
    return {
      status: err.response.status,
      message: errorMessage,
      endpoint: err.request?.responseURL,
    };
  };

  // If there was a network error there won't be a status
  // These are scenarios when axios cannot reach our services for one reason or another
  if (!error.response) {
    window.Rollbar.warn('Client network connectivity issue', error);
    return;
  }

  // Defined globally at window scope in main app index.js
  if (error.response.status >= 500) {
    window.Rollbar.critical(`Api threw ${error.response.status}`, buildRollbarInfo(error));
  } else {
    const errorInfo = buildRollbarInfo(error);
    const handledExpectedError = handleExpectedErrors(errorInfo);
    if (!handledExpectedError) {
      window.Rollbar.error(`Api threw a ${error.response.status} error`, errorInfo);
    }
  }
};

export const logGenericError = (errorName, error) => {
  window.Rollbar.error(errorName, error);
};

export const setRollbarUser = (email, phone) => {
  try {
    window.Rollbar.configure({
      payload: {
        person: {
          id: email,
          email,
        },
        phone,
      },
    });
  } catch (e) {
    // if for any reason configure rollbar were to fail - just ignore it and allow the rest
    // of the action to continue as normal
  }
};

export default new Rollbar({
  enabled: !config.DISABLE_ROLLBAR,
  accessToken: config.ROLLBAR_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  scrubFields: ['accountNumber', 'routingNumber', 'number'],
  payload: {
    environment: config.ROLLBAR_ENV,
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: __GIT_REVISION__, //eslint-disable-line
        guess_uncaught_frames: true,
      },
    },
  },
  // transform copy paste from https://docs.rollbar.com/docs/source-maps/#section-using-source-maps-on-many-domains
  transform(payload) {
    // enables source maps across domains sunrundev, sunrunstage and sunrun
    const { trace } = payload.body;
    const locRegex = /^(https?):\/\/[a-zA-Z0-9._-]+\.(sunrundev|sunrunstage|sunrun)\.com(.*)/; // we have three domains sunrundev, sunrunstage, sunrun
    if (trace && trace.frames) {
      for (let i = 0; i < trace.frames.length; i += 1) {
        //eslint-disable-line
        const { filename } = trace.frames[i];
        if (filename) {
          const m = filename.match(locRegex);
          trace.frames[i].filename = `${m[1]}://dynamichost${m[3]}`; // changed m[2] => m[3] because (sunrundev|sunrunstage|sunrun) creates a new match group
          // m[1] = (https?), m[2] = (sunrundev|sunrunstage|sunrun), m[3] = bundle name (everything after .com)
          // example result: https://dynamichost/bundle.app.8as232as.js
        }
      }
    }
  },
});
